import FJMobileCreationViewContainer from '../FJMainPreview/FJMobileCreationView/FJMobileCreationViewContainer';
import FJMobileHistoryContainer from '../FJMainPreview/FJMobileHistory/FJMobileHistoryContainer';
import FJMobileImageToImageEditContainer from './FJMobileImageToImageEdit/FJMobileImageToImageEditContainer';
import FJMobileImageToImagePresetContainer from './FJMobileImageToImagePreset/FJMobileImageToImagePresetContainer';

const FJMobileImageToImage = () => {
    return (
        <>
            <FJMobileImageToImagePresetContainer />
            <FJMobileCreationViewContainer />
            <FJMobileImageToImageEditContainer />
            <FJMobileHistoryContainer />
        </>
    );
};
export default FJMobileImageToImage;
